// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6534":"ce99d352","7379":"8b28abd9"}[chunkId] + ".chunk.css";
};